import axios from 'axios'
import { ADMIN_API_URL } from 'const'

const BASE_URL = `${ADMIN_API_URL}/reports`

// Every report a person can file (audio-streaming step 6b, step-6-social.md
// "Reports"): a quote, a person (the legacy client's free-text reports among
// them) and, from 6c, a comment, in the one `user_reports` collection. One
// status's rows of every kind, newest first, 50 a page. Page with `before` from
// the previous response's `next_before`, which is null on a short page.
export const listReports = async ({ status, limit, before } = {}) => {
  try {
    const { data } = await axios.get(BASE_URL, {
      params: {
        status,
        ...(limit ? { limit } : {}),
        ...(before ? { before } : {}),
      },
    })
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

// One report, whatever its status: the page a Slack post links to. A row
// written before step 6 carries no status and is reachable only here.
// `not_found` for an unknown id, and for a report the reported account's
// deletion removed.
export const getReport = async ({ reportId }) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/${reportId}`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

// Every report about one person or their quotes and comments, any status,
// newest first, as the list serves rows (2026-11-04), for their profile on the
// Users page: `{ reports, open, more }`, `open` the count still open however
// many rows came back.
export const listForUser = async ({ userId }) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/users/${userId}`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

// The actions, each on one open report and each answering the row. Replaying
// the same one answers the row unchanged; a 409's detail is the message:
// `not_open` (closed another way), `not_a_moment_report`,
// `not_a_comment_report`, `comment_gone`, `no_reported_account`. None is
// automatic and none is bulk.

// Hide the reported quote for everybody (`disabled_reason = admin_disabled`,
// which its owner cannot restore); the report is then actioned.
export const disableMoment = async ({ reportId }) => {
  try {
    const { data } = await axios.put(`${BASE_URL}/${reportId}/disable_moment`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

// Take the reported comment back for everybody (`deleted_reason = admin`, its
// words blanked; every phone retires them from the thread); the report is then
// actioned. `comment_gone` when the thread went with its quote's deleted
// account: the report stays open, to dismiss or to act on the author.
export const tombstoneComment = async ({ reportId }) => {
  try {
    const { data } = await axios.put(
      `${BASE_URL}/${reportId}/tombstone_comment`
    )
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

// Close the report with nothing acted on.
export const dismiss = async ({ reportId }) => {
  try {
    const { data } = await axios.put(`${BASE_URL}/${reportId}/dismiss`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

// Delete the reported account: the same full deletion as `DELETE /users/{id}`.
// That deletion removes every report about the account, this one included, so
// the answer is the row as it stood, actioned, and it is gone from every list.
export const disableAccount = async ({ reportId }) => {
  try {
    const { data } = await axios.put(`${BASE_URL}/${reportId}/disable_account`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}
